<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectRelatedTo,
} from '../../../../model/additional-info/success/info-success-bad-feedback/select-related-to.hook'

defineOptions({
  name: 'SelectRelatedTo',
})

const {
  placeholder,
  model,
  options,
} = useSelectRelatedTo()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
